module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('p', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.title)), _vm._t("label")], 2), _vm._v(" "), (_vm.close) ? _c('span', {
    staticClass: "right",
    on: {
      "click": function () {
        this$1.$emit('close')
      }
    }
  }, [_vm._v("×")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13a224af"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel.vue
// module id = 629
// module chunks = 1